import { render } from "./sticky-header.vue?vue&type=template&id=340107cc&scoped=true"
import script from "./sticky-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./sticky-header.vue?vue&type=script&setup=true&lang=ts"

import "./sticky-header.vue?vue&type=style&index=0&id=340107cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-340107cc"
/* hot reload */
if (module.hot) {
  script.__hmrId = "340107cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('340107cc', script)) {
    api.reload('340107cc', script)
  }
  
  module.hot.accept("./sticky-header.vue?vue&type=template&id=340107cc&scoped=true", () => {
    api.rerender('340107cc', render)
  })

}

script.__file = "resources/ts/components/elements/sticky-header.vue"

export default script